import { Card, Col, Image, Row } from 'react-bootstrap';
import { CustomText } from 'components/CustomText';
import CustomButton from 'components/CustomButton';
import addSign from 'assets/pngs/add.png';
import { isSubstringInArray } from 'helper/formatArray';
import { formatCurrency } from 'helper/formatText';

const DeliverySection = ({
  country,
  currentDeliveryAddress,
  setFreeze,
  setDeliveryAddressVisible,
  deliverMethod,
  setDeliveryMethodVisible,
  deliveryMethod,
  doorDeliveryFee,
  isLoadingGetFreightComRates,
  currencySymbol,
  doorDeliveryService,
  currentDeliveryMethod,
  doorDeliveryError,
}) => {
  return (
    <>
      {!isSubstringInArray('canada', [country?.name]) ? (
        <Col lg={12}>
          <Card className="border-0 mb-4 mb-lg-0 mb-md-0">
            <Card.Header>
              <Row>
                <Col>
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    fontWeight={500}
                    text={'DELIVERY ADDRESS'}
                  />
                </Col>
                <Col className="ms-auto d-flex justify-content-end">
                  {currentDeliveryAddress && (
                    <CustomButton
                      buttonTextColor={'text-primary '}
                      text="CHANGE"
                      variant="primary"
                      fontWeight={500}
                      fontSize={14}
                      style={{
                        padding: 0,
                        height: 20,
                        backgroundColor: 'transparent',
                        border: 'none',
                      }}
                      className="d-flex justify-content-end"
                      onPress={() => {
                        setFreeze(false);
                        setDeliveryAddressVisible(true);
                      }}
                    />
                  )}
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="py-3">
              {!currentDeliveryAddress ? (
                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={14}
                  fontWeight={400}
                  cNColor="text-primary"
                  onPress={() => setDeliveryAddressVisible(true)}
                >
                  <Image src={addSign} style={{ marginRight: 16 }} />
                  Select delivery address
                </CustomText>
              ) : (
                <>
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    fontWeight={600}
                  >
                    {currentDeliveryAddress?.title}
                  </CustomText>
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    cNColor="text-secondary"
                  >
                    {currentDeliveryAddress?.name}
                  </CustomText>
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    cNColor="text-secondary"
                  >
                    {currentDeliveryAddress?.address}
                  </CustomText>
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    cNColor="text-secondary"
                  >
                    {currentDeliveryAddress?.phoneNumber}
                  </CustomText>
                  {currentDeliveryAddress?.additional_info && (
                    <CustomText
                      fontFamily={'Poppins'}
                      fontSize={14}
                      cNColor="text-secondary"
                    >
                      <CustomText fontFamily={'Poppins'} fontSize={14}>
                        Delivery Instructions:
                      </CustomText>
                      {currentDeliveryAddress?.additional_info}
                    </CustomText>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      ) : (
        <Col lg={12}>
          <Card className="border-0 mb-4 mb-lg-0 mb-md-0">
            <Card.Header>
              <Row>
                <Col>
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    fontWeight={500}
                    text={'DELIVERY METHOD'}
                  />
                </Col>
                <Col className="ms-auto d-flex justify-content-end">
                  {!!deliverMethod && currentDeliveryAddress?.address && (
                    <CustomButton
                      buttonTextColor={'text-primary '}
                      text="CHANGE"
                      variant="primary"
                      fontWeight={500}
                      fontSize={14}
                      style={{
                        padding: 0,
                        height: 20,
                        backgroundColor: 'transparent',
                        border: 'none',
                      }}
                      className="d-flex justify-content-end"
                      onPress={() => {
                        setFreeze(false);
                        setDeliveryMethodVisible(true);
                      }}
                    />
                  )}
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="py-3">
              {(!deliverMethod || !currentDeliveryAddress?.address) && (
                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={14}
                  fontWeight={400}
                  cNColor="text-primary"
                  onPress={() => setDeliveryMethodVisible(true)}
                >
                  <Image src={addSign} style={{ marginRight: 16 }} />
                  Select delivery method
                </CustomText>
              )}
              {deliverMethod && currentDeliveryAddress?.address && (
                <>
                  <Col className="d-flex align-items-center">
                    {deliveryMethod?.svg}
                    <CustomText
                      fontFamily={'Poppins'}
                      fontSize={14}
                      fontWeight={600}
                      divClassName="ms-2 mt-2"
                    >
                      {deliveryMethod?.name}
                    </CustomText>
                  </Col>
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    cNColor="text-secondary"
                  >
                    {currentDeliveryAddress?.name}
                  </CustomText>
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    cNColor="text-secondary"
                  >
                    {currentDeliveryAddress?.address}
                  </CustomText>
                  {currentDeliveryAddress?.postal_code && (
                    <CustomText
                      fontFamily={'Poppins'}
                      fontSize={14}
                      cNColor="text-secondary"
                    >
                      {currentDeliveryAddress?.postal_code}
                    </CustomText>
                  )}
                  {currentDeliveryAddress?.phoneNumber && (
                    <CustomText
                      fontFamily={'Poppins'}
                      fontSize={14}
                      cNColor="text-secondary"
                    >
                      {currentDeliveryAddress?.phoneNumber}
                    </CustomText>
                  )}
                  {currentDeliveryAddress?.description && (
                    <CustomText
                      fontFamily={'Poppins'}
                      fontSize={14}
                      cNColor="text-secondary"
                    >
                      {currentDeliveryAddress?.description}
                    </CustomText>
                  )}
                  {currentDeliveryAddress?.additional_info && (
                    <CustomText
                      fontFamily={'Poppins'}
                      fontSize={14}
                      cNColor="text-secondary"
                    >
                      <CustomText fontFamily={'Poppins'} fontSize={14}>
                        Additional Info/Delivery instructions:{' '}
                      </CustomText>
                      {currentDeliveryAddress?.additional_info}
                    </CustomText>
                  )}
                  {((doorDeliveryFee !== 0 && doorDeliveryFee) ||
                    isLoadingGetFreightComRates) && (
                    <div className="d-flex">
                      <CustomText
                        fontFamily={'Poppins'}
                        fontSize={14}
                        divStyle={{ marginRight: 4 }}
                      >
                        Added Delivery fee:{' '}
                      </CustomText>
                      <CustomText
                        fontFamily={'Poppins'}
                        fontSize={14}
                        cNColor="text-primary"
                      >
                        {isLoadingGetFreightComRates
                          ? 'Calculating...'
                          : formatCurrency(
                              parseFloat(doorDeliveryFee),
                              2,
                              currencySymbol
                            )}
                      </CustomText>
                    </div>
                  )}
                  {doorDeliveryService?.carrier_name &&
                    doorDeliveryFee &&
                    !isLoadingGetFreightComRates && (
                      <div className="d-flex">
                        <CustomText
                          fontFamily={'Poppins'}
                          fontSize={14}
                          divStyle={{ marginRight: 4 }}
                        >
                          Domestic Delivery service:
                        </CustomText>
                        <CustomText
                          fontFamily={'Poppins'}
                          fontSize={14}
                          cNColor="text-primary"
                        >
                          {` ${doorDeliveryService?.carrier_name} - ${doorDeliveryService?.service_name}`}
                        </CustomText>
                      </div>
                    )}
                  {!isLoadingGetFreightComRates &&
                    isSubstringInArray(currentDeliveryMethod?.name, ['door']) &&
                    doorDeliveryError && (
                      <CustomText
                        fontFamily={'Poppins'}
                        fontSize={14}
                        cNColor="text-danger"
                      >
                        {doorDeliveryError}
                      </CustomText>
                    )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      )}
    </>
  );
};

export default DeliverySection;
